import { render, staticRenderFns } from "./RoomTablet.vue?vue&type=template&id=5dcdbf8f&scoped=true"
import script from "./RoomTablet.vue?vue&type=script&lang=js"
export * from "./RoomTablet.vue?vue&type=script&lang=js"
import style0 from "./RoomTablet.vue?vue&type=style&index=0&id=5dcdbf8f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dcdbf8f",
  null
  
)

export default component.exports